import {template as tpl, viewModel as SearchFormTemplate} from "../search"
import {IFormTemplate, IResponse, ITableColumn} from "../../../../index";
import {ISearchPageButton} from "../../../search/index";
import {global} from "../../../../appContext";
import {REQUEST_THROTTLE} from "../../../../constants";
import {ICell} from "../../../search/search";
import {createErrorMessage} from "../../../../util/misc";
import {nsFormTemplate} from "../nsFormTemplate";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";

export let template = tpl;

export class viewModel<T = IFormTemplate> extends SearchFormTemplate<T> {

    protected override readonly fnPage: ISearchPageButton[] | KnockoutObservableArray<ISearchPageButton> = [];

    protected override readonly TABLE: ITableColumn[] = [
        {key: 'Id', label: 'Id'},
        {key: 'Name', label: 'Name'},
        {key: 'active', label: 'Active', yesno: true, center: true},
        {key: 'version', label: 'Version', center: true, getContent: o => (o.v2form ? 2 : 1).toString(), validator: () => global.permissionValidator.isMinCompanyAdmin()},
    ];

    protected override onSubmit(throttleDuration: number = REQUEST_THROTTLE) {
        if (!global.login.selectedOrganization() || !this.hasSearchKey()) {
            this.resetSearch();
            return;
        }
        this.reqSearch
            .request(this.getParams(), true, undefined, undefined, throttleDuration)
            .then((resp: IResponse<ICell['item']>) => this.onSearchSuccess(resp))
            .catch((resp: IResponse) => {
                const reason = String(resp?.lasterror ?? resp);
                this._searchMessage(createErrorMessage(String(reason)))
                this.resetSearch()
            })
            .catch((reason: string) => this._searchMessage(createErrorMessage(String(reason))))
        ;

    }

    protected override canRowClick(item: IFormTemplate): boolean {
        return item.active
    }

    protected override onRowClick(item: IFormTemplate) {
            if (item.v2form) {
                nsFormTemplate.openV2form(item, {mode: 'submit'})
                return false
            } else {
                nsFormTemplate.openV1form(item)
                return false
            }
    }

    protected override getSearchSplitButtonParams(): ISplitButtonParams | null {
        return null
    }
    
}
